import script from "./StrikeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./StrikeIcon.vue?vue&type=script&setup=true&lang=js"

export default script